// Locale
// import { en } from '../../locale'
// CANEX THEME CONFIGURATION
import colors from 'vuetify/lib/util/colors';

export const themeConfig = {
  disableCustomizer: false, // options[Boolean] : true, false(default)

  rtl: false, // options[Boolean] : true, false(default)
  verticalSidebarMini: false, // options[Boolean] : true, false(default)
  verticalSidebarDrawer: true, // options[Boolean] : true, false(default)
  verticalCompactSidebarDrawer: true, // options[Boolean] : true, false(default)
  verticalSaasSidebarDrawer: true, // options[Boolean] : true, false(default)
  showBreadcrumb: true, // options[Boolean] : true, false(default)

  layout: 'VerticalSidebar', // VerticalCompactSidebar,VerticalSaasLayout,VerticalSidebar,HorizontalBar,VerticalSix
  isLoading: false,
  isDark: false,
  verticalSidebarDrawerColor: '#191919', // primary,white,sucsess,warning,etc
  appBarColor: '#191919', // primary,white,sucsess,warning,etc
};

// const mq = window.matchMedia("(prefers-color-scheme: light)");

export const themePreset = {
  breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },

  rtl: false,

  theme: {
    // dark: mq.matches,
    dark: false,

    default: 'dark',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: {
      light: {
        white: '#ffffff',
        primary: colors.blue,
        secondary: '#304156',
        detailbg: '#4b5ea2',
        mqcard: '#6e80b5',
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,

        'card-background-light': '#2e2e2e',
        'card-background-mid': '#252525',
        'card-background': '#191919',
        'card-background-darker': '#121212',

        grey: '#666667',

        disabled: '#4D4D4D',
        'disabled-darker': '#333333',

        green: '#428E17',
        'green-dark': '#376c12',
        'green-light': '#73B618',
        'green-lighter': '#0A9A49',

        'purple-dark': '#330750',
        'purple-haze': '#4D3174',
        'purple-light': '#8d35b9',
        'pastel-purple': '#8879B8',
        'light-purple': '#987BB8',

        sky: '#73B5FC',

        main: '#31273a',
        'main-crisp': '#3E135D',
        'main-dark': '#24073D',
        'main-mid': '#43255a',
        'main-light': '#5f407a',
        'main-lighter': '#857ab2',
        'main-lighter-2': '#AE9BCC',
        'main-lighter-3': '#ACA4CD',

        gold: '#F8BF1E',
        'red-bright': '#ff0000',
        'red-error': '#fa0215',

        background: '#1A1D26',
      },
      dark: {
        white: '#ffffff',
        primary: colors.blue,
        secondary: '#304156',
        detailbg: '#4b5ea2',
        mqcard: '#6e80b5',
        success: colors.green,
        danger: colors.red,
        warning: colors.deepOrange,
        info: colors.indigo,

        'card-background-light': '#2e2e2e',
        'card-background-mid': '#252525',
        'card-background': '#191919',
        'card-background-darker': '#121212',

        grey: '#666667',

        disabled: '#4D4D4D',
        'disabled-darker': '#333333',

        green: '#00ff5e',
        'green-dark': '#376c12',
        'green-light': '#73B618',
        'green-lighter': '#0A9A49',

        'purple-dark': '#330750',
        'purple-haze': '#4D3174',
        'purple-light': '#8d35b9',
        'pastel-purple': '#8879B8',
        'light-purple': '#987BB8',

        sky: '#73B5FC',

        main: '#31273a',
        'main-crisp': '#3E135D',
        'main-dark': '#24073D',
        'main-mid': '#4D3174',
        'main-light': '#5f407a',
        'main-lighter': '#857ab2',
        'main-lighter-2': '#AE9BCC',
        'main-lighter-3': '#ACA4CD',

        gold: '#F8BF1E',
        'red-bright': '#ff0000',
        'red-error': '#fa0215',

        background: '#1A1D26',
      },
    },
  },
};
